import shop from "@/api/insurances";

// initial state
const state = {
    all: [],
    insurances: [],
  insurance: {}
};

// getters
const getters = {
  insurance: state => {
    return state.insurance;
  },
  insuranceCategories: state => {
    return state.all.map(m => {
      return {
        name: m.insuranceCategory
          ? m.insuranceCategory.name + " - " + m.name
          : m.name,
        id: m.id
      };
    });
  }
};

// actions
const actions = {
  getAllInsurances: async context => {
    let d = (await shop.getInsurances()).data;
    context.commit("getAllInsurances", d);
  },
  searchInsurance: async (context, insurance) => {
    let d = (await shop.searchInsurance(insurance)).data;
    context.commit("getInsurances", d);
    return d;
  },
  getInsurance: async (context, id) => {
    let d = (await shop.getInsurance(id)).data;
    context.commit("getInsurance", d);
    return d;
  },
  postInsurance: async (context, insurance) => {
    const result = (await shop.postInsurance(insurance)).data;
    context.commit("postInsurance", result);
  },
  putInsurance: async (context, insurance) => {
    const result = (await shop.putInsurance(insurance)).data;
    context.commit("putInsurance", result);
  },
  deleteInsurance: async (context, insurance) => {
    (await shop.deleteInsurance(insurance)).data;
    context.commit("deleteInsurance", insurance);
  }
};

// mutations
const mutations = {
    getInsurances(state, insurances) {
        state.all = insurances;
    },
    getAllInsurances(state, insurances) {
    state.insurances = [{id: -1, name: "Seçiniz"},...insurances];
  },
  getInsurance(state, insurance) {
    //state.insurance = insurance
    state.insurance = null;
    state.insurance = Object.assign({}, state.insurance, insurance);
  },
  postInsurance(state, insurance) {
    //state.insurance = insurance
    state.insurance = null;
    state.insurance = Object.assign({}, state.insurance, insurance);
  },
  putInsurance(state, insurance) {
    //state.insurance = insurance
    state.insurance = null;
    state.insurance = Object.assign({}, state.insurance, insurance);
  },
  deleteInsurance(state, insurance) {
    state.all.splice(state.all.indexOf(insurance), 1);
  },
  decrementInsuranceInventory(state, { id }) {
    const insurance = state.all.find(insurance => insurance.id === id);
    insurance.inventory--;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
